(function() {
    'use strict';
  
    angular
      .module('admin.collector_level.service', [])
      .factory('CollectorLevelService', CollectorLevelService);
  
    /** @ngInject */
    function CollectorLevelService($http, $q, API) {
  
      function list(){
          var defered = $q.defer();
  
          $http.get(API.API_URL + 'admin/collector_level_configurations')
            .success(defered.resolve);
  
          return defered.promise;
      }
    
      function update(id, model){
          var defered = $q.defer();
  
          $http.post(API.API_URL + 'admin/collector_level_configurations/' + id, model)
            .success(defered.resolve);
  
          return defered.promise;
      }

      function listTranslations(id) {
        var defered = $q.defer();
  
        $http
          .get(API.API_URL + "admin/collector_level_configurations/" + id + "/collector_level_configuration_translations")
          .success(defered.resolve)
          .error(defered.reject);
  
        return defered.promise;
      }
  
      function getTranslation(id) {
        var defered = $q.defer();
  
        $http.get(API.API_URL + "admin/collector_level_configuration_translations/" + id).success(defered.resolve);
  
        return defered.promise;
      }
  
      function saveTranslation(id, model) {
        var defered = $q.defer();
  
        $http
          .post(API.API_URL + "admin/collector_level_configurations/" + id + "/collector_level_configuration_translations?automatic=true", model)
          .success(defered.resolve)
          .error(defered.reject);
  
        return defered.promise;
      }
  
      function updateTranslation(id, model) {
        var defered = $q.defer();
  
        $http
          .put(API.API_URL + "admin/collector_level_configuration_translations/" + id + '?automatic=true', model)
          .success(defered.resolve)
          .error(defered.reject);
  
        return defered.promise;
      }
  
      function removeTranslation(id) {
        var defered = $q.defer();
  
        $http
          .delete(API.API_URL + "admin/collector_level_configuration_translations/" + id)
          .success(defered.resolve)
          .error(defered.reject);
  
        return defered.promise;
      }
  
      return{
        list: list,
        update: update,
        listTranslations: listTranslations,
        getTranslation: getTranslation,
        saveTranslation: saveTranslation,
        updateTranslation: updateTranslation,
        removeTranslation: removeTranslation
      };
  
    }
  
  })();
  